import {
    Box,
    Paper,
    Stack,
    Typography,
    Button,
    Chip,
    Divider,
    alpha,
} from "@mui/material"
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded"

export default function ConvenioPendienteAviso({
    clienteNombre
}) {
    return (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Paper
                elevation={0}
                sx={{
                    position: "relative",
                    overflow: "hidden",
                    width: "100%",
                    maxWidth: 720,
                    borderRadius: 4,
                    p: { xs: 3, sm: 5 },
                    textAlign: "center",
                    border: "1px solid",
                    borderColor: (theme) => alpha(theme.palette.warning.main, 0.4),
                    bgcolor: (theme) => alpha(theme.palette.warning.main, 0.06),
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        height: 6,
                        bgcolor: "warning.main",
                    }}
                />

                <Stack spacing={1} alignItems="center">
                    <Box
                        sx={{
                            width: 96,
                            height: 96,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            bgcolor: (theme) => alpha(theme.palette.warning.main, 0.15),
                        }}
                    >
                        <WarningAmberRoundedIcon
                            sx={{ fontSize: 52, color: "warning.dark" }}
                        />
                    </Box>
                    <Box>
                        <Typography
                            variant="h5"
                            component="h2"
                            sx={{ fontWeight: 700, mb: 1 }}
                        >
                            Falta registrar el convenio del cliente
                        </Typography>
                        <Typography
                            variant="body1"
                            color="text.secondary"
                            sx={{ maxWidth: 520, mx: "auto", lineHeight: 1.6 }}
                        >
                            Por favor, registre la situacion frente a{" "}
                            <strong>Ingresos Brutos</strong>
                            {clienteNombre ? (
                                <>
                                    {" "}
                                    de <strong>{clienteNombre}</strong>
                                </>
                            ) : (
                                " del cliente"
                            )}{" "}
                            antes de registrar sus inscripciones.
                        </Typography>
                    </Box>

                    <Divider flexItem sx={{ borderColor: (theme) => alpha(theme.palette.warning.main, 0.25) }} />
                    <Typography
                        variant="subtitle1"
                        color="text.secondary"
                        sx={{ maxWidth: 520, mx: "auto", lineHeight: 1.6, fontSize: 12 }}
                    >
                        Para registrar la situacion frente a Ingresos Brutos, diríjase a la sección "datos" del cliente. Allí podrá ingresar convenio y N° de inscripción.
                    </Typography>
                </Stack>
            </Paper>
        </Box>
    )
}
